import React, { useContext, useEffect, useRef } from "react";
import { Stack } from "@mui/material";
import dayjs from "dayjs";
import DatePickerWithPresets from "src/components/widgets/date-picker-with-presets/DatePickerWithPresets";
import DateTimeContext from "src/contexts/DateTimeContext";

const FilterFieldDate = ({ value, onChange, label }) => {
  const dateChanged = useRef(false);
  const { getTimeZoneDate } = useContext(DateTimeContext);

  const getDefaultDates = () => {
    const startOfDay = getTimeZoneDate().startOf("d");
    const endOfDay = getTimeZoneDate().endOf("d");
    return [startOfDay, endOfDay];
  };

  useEffect(() => () => {
    if (!value && !dateChanged.current) {
      onChange({ value: getDefaultDates() });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, onChange]);

  const handleDateChange = (startDate, endDate) => {
    dateChanged.current = true;

    if (startDate.isAfter(endDate)) {
      onChange({ value: null });
      return;
    }

    onChange({ value: [startDate, endDate] });
  };

  return (
    <Stack sx={{ padding: theme => theme.spacing(2, 0) }}>
      <DatePickerWithPresets
        dates={value || getDefaultDates()}
        setDates={handleDateChange}
        testId={`filter-${label}`}
        showStandaloneDatePicker
      />
    </Stack>
  );
};

export default FilterFieldDate;

